export default {
 
  settingsDriver_search: "Search by Driver, Code or Supervisor",
  settingsDriver_driver: "Driver Name",
  settingsDriver_name: "Name",
  settingsDriver_licenseNumber: "License Number",
  settingsDriver_registrationState: "Registration State",
  settingsDriver_registrationCountry: "Registration Country",
  settingsDriver_driverPin: "Pin Number",
  settingsDriver_email: "Email",
  settingsDriver_notifyByEmail: "You want to receive email notifications?",
  settingsDriver_indicator: "Indicator",
  settingsDriver_phone: "Phone",
  settingsDriver_phoneNumber: "Phone Number",
  settingsDriver_notifyBySms: "You want to receive SMS notifications?",
  settingsDriver_vehicle: "Vehicle",
  settingsDriver_zonarELD: "Hours of Service Ruleset",
  settingsDriver_zonarELDExempt: "Hours of Service Exempt",
  settingsDriver_timezone: "Timezone",
  settingsDriver_contact: "Contact",
  settingsDriver_contactDetails: "Contact Details",
  settingsDriver_supervisor: "Supervisor",
  settingsDriver_supervisorPlaceHolder: "Select Supervisor",
  settingsDriver_cellphone: "Cell phone",
  settingsDriver_carrier: "Carrier",
  settingsDriver_address: "Address",
  settingsDriver_username: "Username",
  settingsDriver_password: "Password",
  settingsDriver_repeatPassword: "Repeat Password",
  settingsDriver_repeatPasswordDoNotMatch: "Passwords do not match",
  settingsDriver_defaultTab: "Default Tab",
  settingsDriver_create: "Create new Driver",
  settingsDriver_edit: "Edit Driver",
  settingsDriver_delete: "Delete Driver",
  settingsDriver_created: "Driver was created successfully",
  settingsDriver_updated: "Driver was updated successfully",
  settingsDriver_deleted: "Driver was deleted successfully",
  settingsDriver_fsmLogin: "Ignition Driver app",
  settingsDriver_supervisor: "Supervisor",
  settingsDriver_addFsmLogin: "Edit to Create",
  settingsDriver_minLengthMessageName: "The username must contain a minimum of characters:",
  settingsDriver_maxLengthMessageName: "The username must contain a maximum of characters:",
  settingsDriver_exactLengthMessagePin: "The Pin Number must must be exactly 4 digits.",
  settingsDriver_minLengthMessagePassword: "The password must contain a minimum of characters:",
  settingsDriver_maxLengthMessagePassword: "The password must contain a maximum of characters:",
  settingsDriver_maxLengthMessageCellPhone: "The cell phone must contain a maximum of characters:",
  settingsDriver_minLengthMessageCellPhone: "The cell phone must contain a minimum of characters:",
  settingsDriver_addressMessage: "The address is incorrect",
  settingsDriver_descriptonDelete: "Are you sure you want to delete the Drivers?",
  settingsDriver_fmsLoginMessage: "To create or edit the Ignition Driver App login, it is necessary to add the two fields below:",
  settingsDriver_fmsLoginPwdRequired: 'The password is required',
  settingsDriver_hasVideoAccess: 'Has Video Access',
  settingsDriver_import: "Driver uploads",
  settingsDriver_import_driver: "Import Drivers",
  settingsDriver_descriptonImport: "Import CSV File",
  settingsDriver_delimiter: "Delimiter",
  settingsDriver_file: "File",
  settingsDriver_upload: "Upload",
  settingsDriver_error_delimiter: "Error in file, please review the delimiter",
  settingsDriver_error_name_required: "Driver name and Tag is required",
  settingsDriver_error_name_repeat: "Driver name already exists",
  settingsDriver_error_name_repeat_file: "Driver name or Email is repeated",
  settingsDriver_error_fix: "Please fix errors before continuing",
  settingsDriver_error_started: " The import has been started, you will be notified when completed",
  settingsDriver_error_required: "Required File CSV",
  settingsDriver_template: "Driver Template",
  settingsDriver_aceept_file: "Only accept csv files",
  settingsDriver_email: 'Email',
  settingsDriver_group: 'Tag',
  settingsDriver_error: 'Error',
  settingsDriver_semicolon: 'Semicolon',
  settingsDriver_comma: 'Comma',
  settingsDriver_resume:'Transaction resume',
  settingsDriver_importation_title:'Import finished',
  settingsDriver_importation_body:'To see the summary click here',
  settingsDriver_status:'Status',
  settingsDriver_tag:'Tag',
  settingsDriver_employeeNumber:'Employee Number',
  settingsDriver_licenseExpDate: "License Expiration Date",
  settingsDriver_id: "ID",
  settingsDriver_driverPin: "Pin Number",
  settingsDriver_licenseNumber: "License Number",
  settingsDriver_licenseCountry: "Registration Country",
  settingsDriver_licenseState: "Registration State",
  settingsDriver_timezone: "Timezone",
  settingsDriver_hosRuleSet: "Hours of Service Ruleset",
  settingsDriver_hosExempt: "Hours of Service Exempt",
  settingsDriver_hosExemptComment: "Exempt Comment",
  settingsDriver_personalConveyance: "Personal Conveyance",
  settingsDriver_allowedPCDistance: "Allowed PC Distance",
  settingsDriver_personalYardMoves: "Yard Moves",

  settingsDriver_select_delimiter: "Select",
  drivers_import_instructions: 'Important Note: The ID column is mandatory. If the import process is intended to update existing records, perform a table export without editing the ID column value to maintain the record reference. If you want to create new drivers, leave the ID column blank.',
  drivers_download_template: 'Download Template',

  settingsDriver_filterBy:'Filter by',
  settingsDriver_clearFilters:'Clear filters',

  settingsDriver_all: "All",
  settingsDriver_tags: "Tags",
  settingsDriver_units: "Units",
  settingsDriver_unassigned: "Unassigned",
  settingsDriver_drivers: "Drivers",
  settingsDriver_driversFaces: "Drivers Faces",
  settingsDriver_driversFacesAssign: "Assign Driver",
  settingsDriver_driversFacesAll: "All",
  settingsDriver_driversFacesLinked: "Linked",
  settingsDriver_driversFacesUnlinked: "Unlinked",
  settingsDriver_driversFacesNoVh: "No Vehicle Assigned",
  settingsDriver_driversFacesSelectTempUrl: 'select this image as temporary avatar',
  settingsDriver_driversFacesDetele: 'Delete this face',
  settingsDriver_driversFacesAssignedTo: "Assigned To",
  settingsDriver_driversFacesSelectDriver: "Assign these faces to the driver:",
  settingsDriver_driversFacesCleanSeleted: "Deselect all",
  settingsDriver_driversFacesUpdateSuccess: "the selected images were correctly assigned to the selected driver",
  settingsDriver_driversFacesUpdateError: "An error occurred while assigning the images",
  settingsDriver_driversFacesdeleteCollection: "Are you sure you want to delete these driver collections?",
  settingsDriver_driversFacesDeleteCollectionSuccess: "the driver collection was successfully deleted",
  settingsDriver_driversFacesDeleteCollectionError: "An error occurred deleting the driver collection",
  settingsDriver_driversFacesDeleteCollectionTitle: "Delete Driver Collection",
  settingsDriver_driversFacesdeleteFaceId: "Are you sure you want to delete this face from this collection? This action can't be undone",
  settingsDriver_driversFacesdeleteFaceIdTitle: "Delete face from this collection",
  settingsDriver_driversFacesNoFaceDetected: "This collection has no images",


  settingsDriver_driversTagDelete: "Remove Drivers From Tags",
  settingsDriver_descriptonDriversTagDelete: "Are you sure you want to remove the drivers from the following tags?",
  settingsDriver_deletedDriversTag: "Drivers were removed from tags successfully",
  settingsDriver_searchTags: "Search by Tag",
  settingsDriver_avatar: "Profile Picture",
  settingsDriver_timeCard: "Time Card",
  settingsDriver_changeStatus: "Change Status",
  settingsDriver_successChangeStatus: "The status has been changed",
  settingsDriver_change: "Change",

  settingsDriver_externalId: "Code",
  settingsDriver_error_externalID_repeat: "Driver Code already exists",
  settingsDriver_error_externalID_long: "Driver Code to long, maximum 10 characters",
  settingsDriver_error_externalID: "Driver Code must contains only numbers and letters",
  settingsDriver_error_duplicated: "There is already a driver with the contact details, Code or name entered",
  settingsDriver_codeDuplicated: "Code duplicated",
  settingsDriver_error_username_duplicated: "There is already a driver with the username entered",
  settingsDriver_error_invalid_name: "Driver name is invalid, please remove numbers and special characters",

  settingsDriver_yes: "Yes",
  settingsDriver_no: "No",

  settingsDriver_invalidEmail: "Invalid email, please enter a valid email address",
  settingsDriver_resetPassword: "Reset Credentials",
  settingsDriver_invalidUsername: "Invalid username, please enter a valid username",
  settingsDriver_invalidPassword: "Invalid password, please enter a valid password",
  settingsDriver_resetPasswordSuccess: "Password reset successfully",
  settingsDriver_errorMessageDeleteDriver: "It is not possible to delete drivers who have active work orders assigned to them, please cancel the work orders before deleting the drivers",
  settingsDriver_errorMessageCreateDriver: "Driver details, Code, Name or KeyFob duplicated, please check the information entered",
  settingsDriver_avatar: "Avatar",
  settingsDriver_workOrderError: "It is not possible to inactivate the driver because it has active work orders assigned to it",
  settingsDriver_usernameError: "The username for the driver is duplicated.",
  settingsDriver_usernameErrorLength: "The username must contain between 4 and 12 characters",
  settingsDriver_invalidDriverPin: "The driver pin must contain only numbers",
  settingsDriver_invalidLicenseNumber: "The license number must contain only numbers",
  settingsDriver_licenseNumberError: "The license number is duplicated",
  settingsDriver_driverPinError: "The driver pin must be a positive number",
  settingsDriver_zonarELDExemptComment: "Exempt Comment",
  settingsDriver_zonarELDExemptCommentError: "If the driver is exempt from the HOS ruleset, the Exempt Comment is required",
  settingsDriver_keyFobHex: "KeyFob",
  settingsDriver_keyFobHexError: "The key fob is duplicated",
  settingsDriver_keyFobAlreadyAssigned: "Key Fob already assigned to driver",
  settingsDriver_companyReadonly: "Company is read-only",
  settingsDriver_nameMinLength: "The name must contain minimum 2 chars",
  settingsDriver_invalidContactInfo: "Invalid contact info",
  settingsDriver_usernameNoSpaces: "Username must not have spaces.",
  settingsDriver_passwordMinLength: "The password must contain minimum 6 chars",
  settingsDriver_unitForbidden: "Forbidden, you don't have access to this unit",
  settingsDriver_driverForbidden: "Forbidden, you don't access to this driver",
  settingsDriver_timezoneNotFound: "The timezone does not exist.",
  settingsDriver_allowedPCDistanceMinError: "Allowed PC Distance must be at least 5 miles (8 km)",
  settingsDriver_allowedPCDistanceMaxError: "Allowed PC Distance must not exceed 1608 km (1000 miles)",
  settingsDriver_eldRequiredFields: "required for ELD-enabled accounts.",
  settingsDriver_eldRequiredAnd: "and",
  settingsDriver_eldRequiredIs: "is",
  settingsDriver_eldRequiredAre: "are",

  settingsDriver_invalidUsernameLength: "The username must contain a minimum of 4 characters and a maximum of 12 characters",

  settingsDriver_passwordRequired: "If you want to create a new driver username, the password is required",
  settingsDriver_passwordRequiredToCreateOrEdit: "The password is required",
  settingsDriver_email_already_exists: "Email already exists",
  settingsDriver_minLengthMessageLicenseNumber: "The license number must contain a minimum of 7 characters",
  settingsDriver_minLengthMessageExternalId: "The code must contain a minimum of 3 characters",
  settingsDriver_externalIdDigitsOnly: "The code must contain only numbers",
  settingsDriver_minLengthMessageEmployeeNumber: "The employee number must contain a minimum of 12 characters",
  settingsDriver_specialDutyStatuses: 'Special Duty Statuses:',
  settingsDriver_personalConveyance: 'Personal Conveyance',
  settingsDriver_personalYardMoves: 'Yard Moves',
  settingsDriver_allowedPCDistance: 'Allowed PC Distance',
  settingsDriver_allowedPCDistanceError: 'The allowed PC distance must be greater than',

  // Import error codes translations (from backend)
  drivers_import_error_D001: 'Missing required field: Code',
  drivers_import_error_D002: 'Missing required field: Driver Name',
  drivers_import_error_D003: 'Missing required field: Employee Number',
  drivers_import_error_D004: 'Missing required field: Pin Number',
  drivers_import_error_D005: 'Missing required field: License Number',
  drivers_import_error_D006: 'Missing required field: Registration Country',
  drivers_import_error_D007: 'Missing required field: Registration State',
  drivers_import_error_D008: 'Missing required field: Timezone',
  drivers_import_error_D009: 'Missing required field: Tags',
  drivers_import_error_D010: 'Missing required field: KeyFob',
  drivers_import_error_D011: 'Missing required field: Hours of Service Ruleset (required when Zonar ELD is enabled)',
  drivers_import_error_D012: 'Processing error occurred',
  drivers_import_error_D020: 'Code exceeds maximum length of 40 characters',
  drivers_import_error_D021: 'Driver Name exceeds maximum length of 100 characters',
  drivers_import_error_D022: 'Employee Number exceeds maximum length of 20 characters',
  drivers_import_error_D023: 'Pin Number exceeds maximum length of 4 characters',
  drivers_import_error_D024: 'License Number exceeds maximum length of 15 characters',
  drivers_import_error_D025: 'KeyFob exceeds maximum length of 20 characters',
  drivers_import_error_D026: 'Email exceeds maximum length of 50 characters',
  drivers_import_error_D027: 'Phone Number exceeds maximum length of 10 characters',
  drivers_import_error_D030: 'Invalid License Expiration Date format',
  drivers_import_error_D031: 'Invalid email format',
  drivers_import_error_D032: 'Phone Number must contain only digits',
  drivers_import_error_D033: 'Allowed PC Distance must be a valid number',
  drivers_import_error_D037: 'Allowed PC Distance must not exceed 1608 km (1000 miles)',
  drivers_import_error_D040: 'Tags not found',
  drivers_import_error_D041: 'No permission for tags',
  drivers_import_error_D042: 'Driver with ID not found',
  drivers_import_error_D043: 'Driver name already exists (duplicate)',
  drivers_import_error_D047: 'Code already exists (duplicate)',
  drivers_import_error_D050: 'Error creating driver',
  drivers_import_error_D051: 'Error updating driver',
  drivers_import_error_D052: 'Exempt Comment must be empty when Hours of Service Exempt is No',
  drivers_import_error_D053: 'No changes detected for driver.',
  drivers_import_partial_success: 'Import completed with some errors. Check the transaction summary.',
  drivers_import_failed: 'Import failed. Please check the file and try again.',
  drivers_import_cancel: 'Cancel',
  drivers_import_button: 'Import',
};